import * as React from 'react';
import * as styles from './styles.css';

export function Layout({ children, stretch, testId }: React.PropsWithChildren<{ stretch?: boolean; testId?: string }>) {
  return (
    <div className={stretch ? styles['stretch'] : styles['container']} data-testid={testId}>
      {children}
    </div>
  );
}
